const Rmnch = {
  content: {
    program_area: 'RMNCH',
    indicators: [
      {
        id: 1,
        full_name: 'Total fertility rate',
        short_name: 'Total Fertility Rate',
        desirable_slope: 'Negative',
        indicator_type: 'Impact',
        program_area: 'RMNCH',
        national_target: '0.00',
        national_source: 'Not available',
        national_information: 'Not available',
        sdg_target: null,
        sdg_information: 'Not available',
        created_at: '2022-10-20T08:42:09.544144Z',
        updated_at: '2024-01-18T08:59:11.891732Z',
        factor: 4,
        first_related: 2,
        second_related: 3,
        third_related: 4,
        fourth_related: null,
        datasources: [
          1,
          2,
          4,
          6,
          7,
          8,
          9,
          15,
          18,
          30,
        ],
        group: [],
      },
      {
        id: 2,
        full_name: 'Adolescent birth rate',
        short_name: 'Adolescent birth rate',
        desirable_slope: 'Negative',
        indicator_type: 'Impact',
        program_area: 'RMNCH',
        national_target: '90.00',
        national_source: 'NSHDP 2010 to 2015',
        national_information: 'Target was obtained from the National Strategic and Health Development Plan (NSHDP) 2010 to 2015. It is the latest available target for this indicator.',
        sdg_target: null,
        sdg_information: 'Not available',
        created_at: '2022-10-20T08:42:09.550494Z',
        updated_at: '2024-01-18T08:59:15.846925Z',
        factor: 1,
        first_related: 1,
        second_related: 4,
        third_related: 3,
        fourth_related: null,
        datasources: [
          1,
          2,
          4,
          6,
          7,
          8,
          9,
          15,
          18,
          30,
        ],
        group: [],
      },
      {
        id: 3,
        full_name: 'Unmet need for family planning',
        short_name: 'Unmet need for family planning',
        desirable_slope: 'Negative',
        indicator_type: 'Impact',
        program_area: 'RMNCH',
        national_target: '8.00',
        national_source: 'NRHP 2017',
        national_information: 'Target obtained from the National Reproductive Health Policy (NRHP) 2017 to 2021',
        sdg_target: null,
        sdg_information: 'Not available',
        created_at: '2022-10-20T08:42:09.552264Z',
        updated_at: '2023-05-12T11:09:41.783442Z',
        factor: 2,
        first_related: 4,
        second_related: 1,
        third_related: 2,
        fourth_related: null,
        datasources: [
          1,
          2,
          7,
          25,
        ],
        group: [],
      },
      {
        id: 4,
        full_name: 'Contraceptive prevalence rate',
        short_name: 'Contraceptive prevalence rate',
        desirable_slope: 'Positive',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: '43.00',
        national_source: 'NSHDP II & NRHP 2017',
        national_information: 'Target obtained from the National Reproductive Health Policy (NRHP) 2017 to 2021',
        sdg_target: null,
        sdg_information: 'Not available',
        created_at: '2022-10-20T08:42:09.554000Z',
        updated_at: '2024-01-18T08:59:13.531577Z',
        factor: 2,
        first_related: 3,
        second_related: 1,
        third_related: 2,
        fourth_related: null,
        datasources: [
          1,
          2,
          5,
          6,
          7,
          9,
          15,
          30,
          3,
        ],
        group: [],
      },
      {
        id: 5,
        full_name: 'ANC Coverage (at least 1 visit)',
        short_name: 'ANC Coverage (at least 1 visit)',
        desirable_slope: 'Positive',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: 'Not available',
        national_information: 'Not available',
        sdg_target: '',
        sdg_information: 'Not available',
        created_at: '2022-10-20T08:42:09.555716Z',
        updated_at: '2024-01-18T08:59:03.356783Z',
        factor: 2,
        first_related: 6,
        second_related: 7,
        third_related: 8,
        fourth_related: null,
        datasources: [
          1,
          2,
          4,
          5,
          6,
          7,
          15,
          25,
          30,
          3,
        ],
        group: [],
      },
      {
        id: 6,
        full_name: 'ANC Coverage (4 visits)',
        short_name: 'ANC Coverage (4 visits)',
        desirable_slope: 'Positive',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: '80.00',
        national_source: 'NRHP 2017',
        national_information: 'Target obtained from the National Reproductive Health Policy (NRHP) 2017 to 2021',
        sdg_target: null,
        sdg_information: 'Not available',
        created_at: '2022-10-20T08:42:09.557458Z',
        updated_at: '2024-01-18T08:59:04.278682Z',
        factor: 2,
        first_related: 5,
        second_related: 8,
        third_related: 7,
        fourth_related: 29,
        datasources: [
          1,
          2,
          4,
          5,
          6,
          7,
          9,
          15,
          25,
          30,
          3,
        ],
        group: [],
      },
      {
        id: 7,
        full_name: 'Skilled attendance at delivery or birth',
        short_name: 'Skilled birth attendance',
        desirable_slope: 'Positive',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: '57.00',
        national_source: 'NSHDP II & NRHP 2017',
        national_information: 'Target obtained from the National Reproductive Health Policy (NRHP) 2017 to 2021',
        sdg_target: null,
        sdg_information: 'Not available',
        created_at: '2022-10-20T08:42:09.559170Z',
        updated_at: '2024-01-18T08:59:11.096661Z',
        factor: 2,
        first_related: 6,
        second_related: 5,
        third_related: 8,
        fourth_related: 29,
        datasources: [
          1,
          2,
          5,
          6,
          7,
          8,
          9,
          15,
          30,
          3,
        ],
        group: [],
      },
      {
        id: 8,
        full_name: 'Postnatal care coverage (mother)',
        short_name: 'Postnatal care coverage',
        desirable_slope: 'Positive',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: '80.00',
        national_source: 'NRHP 2017',
        national_information: 'Target obtained from the National Reproductive Health Policy (NRHP) 2017 to 2021',
        sdg_target: null,
        sdg_information: 'Not available',
        created_at: '2022-10-20T08:42:09.560835Z',
        updated_at: '2023-03-16T15:29:08.616312Z',
        factor: 2,
        first_related: 6,
        second_related: 5,
        third_related: 7,
        fourth_related: null,
        datasources: [
          1,
          2,
          7,
          3,
        ],
        group: [],
      },
      {
        id: 9,
        full_name: 'Prevalence of children with diarrhoea',
        short_name: 'Prevalence of children with diarrhoea',
        desirable_slope: 'Negative',
        indicator_type: 'Impact',
        program_area: 'RMNCH',
        national_target: '0.00',
        national_source: 'Not available',
        national_information: 'Not available',
        sdg_target: null,
        sdg_information: 'Not available',
        created_at: '2022-10-20T08:42:09.562496Z',
        updated_at: '2023-03-16T15:45:32.421279Z',
        factor: 2,
        first_related: 10,
        second_related: 12,
        third_related: null,
        fourth_related: null,
        datasources: [
          1,
          2,
          5,
          8,
          15,
        ],
        group: [],
      },
      {
        id: 10,
        full_name: 'Percentage of children with diarrhoea who received treatment',
        short_name: '% children with diarrhoea who received treatment',
        desirable_slope: 'Positive',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: '0.00',
        national_source: 'Not available',
        national_information: 'Not available',
        sdg_target: null,
        sdg_information: 'Not available',
        created_at: '2022-10-20T08:42:09.564192Z',
        updated_at: '2023-11-20T12:59:09.536662Z',
        factor: 2,
        first_related: 9,
        second_related: 11,
        third_related: null,
        fourth_related: null,
        datasources: [
          1,
          2,
          5,
          7,
          8,
          9,
          30,
        ],
        group: [],
      },
      {
        id: 11,
        full_name: 'Prevalence of Symptoms of Acute Respiratory Infection among under five children',
        short_name: 'Prevalence of ARI in children <5 years',
        desirable_slope: 'Negative',
        indicator_type: 'Impact',
        program_area: 'RMNCH',
        national_target: '0.00',
        national_source: 'Not available',
        national_information: 'Not available',
        sdg_target: null,
        sdg_information: 'Not available',
        created_at: '2022-10-20T08:42:09.565884Z',
        updated_at: '2023-03-15T07:40:01.773516Z',
        factor: 2,
        first_related: 12,
        second_related: 10,
        third_related: null,
        fourth_related: null,
        datasources: [
          1,
          2,
          5,
        ],
        group: [],
      },
      {
        id: 12,
        full_name: 'Proportion of children under 5 with ARI who received antibiotics',
        short_name: 'Children <5 years with ARI given antibiotics',
        desirable_slope: 'Positive',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: '0.00',
        national_source: 'Not available',
        national_information: 'Not available',
        sdg_target: null,
        sdg_information: 'Not available',
        created_at: '2022-10-20T08:42:09.567500Z',
        updated_at: '2023-11-29T16:27:23.688404Z',
        factor: 2,
        first_related: 11,
        second_related: 10,
        third_related: 9,
        fourth_related: null,
        datasources: [
          1,
          2,
          5,
          9,
          15,
        ],
        group: [],
      },
      {
        id: 69,
        full_name: 'Life Expectancy at birth',
        short_name: 'Life Expectancy at birth',
        desirable_slope: 'Positive',
        indicator_type: 'Impact',
        program_area: 'RMNCH',
        national_target: '0.00',
        national_source: 'Not available',
        national_information: 'Not available',
        sdg_target: null,
        sdg_information: 'Not available',
        created_at: '2022-10-20T08:42:09.663932Z',
        updated_at: '2023-12-06T15:30:40.546793Z',
        factor: 4,
        first_related: 71,
        second_related: 70,
        third_related: null,
        fourth_related: null,
        datasources: [
          7,
          18,
        ],
        group: [],
      },
      {
        id: 395,
        full_name: 'Net Reproduction rate',
        short_name: 'Net Reproduction rate',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: '0.00',
        national_source: 'Not available',
        national_information: 'Not available',
        sdg_target: null,
        sdg_information: 'Not available',
        created_at: '2022-10-20T08:42:10.359253Z',
        updated_at: '2022-12-15T00:38:33.229937Z',
        factor: 4,
        first_related: null,
        second_related: null,
        third_related: null,
        fourth_related: null,
        datasources: [
          18,
          8,
        ],
        group: [],
      },
      {
        id: 396,
        full_name: 'Human Development Index',
        short_name: 'HDI',
        desirable_slope: 'Positive',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: '0.00',
        national_source: 'Not available',
        national_information: 'Not available',
        sdg_target: null,
        sdg_information: 'Not available',
        created_at: '2022-10-20T08:42:10.361040Z',
        updated_at: '2022-12-15T00:38:35.215320Z',
        factor: 4,
        first_related: null,
        second_related: null,
        third_related: null,
        fourth_related: null,
        datasources: [
          29,
        ],
        group: [],
      },
      {
        id: 398,
        full_name: 'Postnatal care coverage (newborn)',
        short_name: 'Postnatal care coverage (newborn)',
        desirable_slope: 'Positive',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: '0.00',
        national_source: 'Not available',
        national_information: 'Not available',
        sdg_target: '',
        sdg_information: 'Not available',
        created_at: '2022-10-20T08:42:10.364839Z',
        updated_at: '2024-01-18T08:59:22.139396Z',
        factor: 2,
        first_related: 7,
        second_related: 8,
        third_related: null,
        fourth_related: null,
        datasources: [
          1,
          2,
          6,
          15,
          30,
        ],
        group: [],
      },
      {
        id: 572,
        full_name: 'Mean age of childbearing',
        short_name: 'Mean age of childbearing',
        desirable_slope: 'Positive',
        indicator_type: 'Impact',
        program_area: 'RMNCH',
        national_target: null,
        national_source: 'Not available',
        national_information: 'Not available',
        sdg_target: null,
        sdg_information: 'Not available',
        created_at: '2023-01-25T13:50:29.941605Z',
        updated_at: '2023-08-15T09:16:30.091082Z',
        factor: 4,
        first_related: null,
        second_related: null,
        third_related: null,
        fourth_related: null,
        datasources: [
          19,
        ],
        group: [],
      },
      {
        id: 636,
        full_name: 'Percentage of households with a stillbirth or neonatal death within <30 mins of place to buy drugs',
        short_name: '% of households within <30 mins of place to buy drugs',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:50:50.323311Z',
        updated_at: '2023-05-24T10:14:29.051620Z',
        factor: 2,
        first_related: 637,
        second_related: 638,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 637,
        full_name: 'Percentage of households with a stillbirth or neonatal death within 1 hour or more of place to buy drugs',
        short_name: '% of households within 1 hour or more of place to buy drugs',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:50:51.744375Z',
        updated_at: '2023-05-24T10:14:38.065347Z',
        factor: 2,
        first_related: 636,
        second_related: 638,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 638,
        full_name: 'Percentage of households with a stillbirth or neonatal death within walking distance of place to buy drugs',
        short_name: '% of households within walking distance of place to buy drugs',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:50:53.405262Z',
        updated_at: '2023-05-24T10:14:47.735783Z',
        factor: 2,
        first_related: 637,
        second_related: 636,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 639,
        full_name: 'Percentage of households with a stillbirth or neonatal death within <30 mins of place for outpatient services',
        short_name: '% of households within <30 mins of place for outpatient services',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:50:54.940326Z',
        updated_at: '2023-05-24T10:14:56.964805Z',
        factor: 2,
        first_related: 641,
        second_related: 640,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 640,
        full_name: 'Percentage of households with a stillbirth or neonatal death within 1 hour or more of place for outpatient services',
        short_name: '% of households within 1 hour or more of place for outpatient services',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:50:56.416875Z',
        updated_at: '2023-05-24T10:15:06.829534Z',
        factor: 2,
        first_related: 639,
        second_related: 641,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 641,
        full_name: 'Percentage of households with a stillbirth or neonatal death within walking distance of place for outpatient services',
        short_name: '% of households within walking distance of place for outpatient services',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:50:57.937396Z',
        updated_at: '2023-05-24T10:15:16.911902Z',
        factor: 2,
        first_related: 639,
        second_related: 640,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 642,
        full_name: 'Percentage of households with a stillbirth or neonatal death within <30 mins of place for delivery services',
        short_name: '% of households within <30 mins of place for delivery services',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:50:59.242043Z',
        updated_at: '2023-05-24T10:15:25.150704Z',
        factor: 2,
        first_related: 643,
        second_related: 644,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 643,
        full_name: 'Percentage of households with a stillbirth or neonatal death within 1 hour or more of place for delivery services',
        short_name: '% of households within 1 hour or more of place for delivery services',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:00.677425Z',
        updated_at: '2023-05-24T10:15:35.073925Z',
        factor: 2,
        first_related: 642,
        second_related: 644,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 644,
        full_name: 'Percentage of households with a stillbirth or neonatal death within walking distance of place for delivery services',
        short_name: '% of households within walking distance of place for delivery services',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:02.080873Z',
        updated_at: '2023-05-24T10:15:44.578616Z',
        factor: 2,
        first_related: 642,
        second_related: 643,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 645,
        full_name: 'Percentage of households with a stillbirth or neonatal death within <30 mins of place for inpatient care/hospital',
        short_name: '% of households within <30 mins of place for inpatient care/hospital',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:03.366785Z',
        updated_at: '2023-05-24T10:15:53.839870Z',
        factor: 2,
        first_related: 646,
        second_related: 647,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 646,
        full_name: 'Percentage of households with a stillbirth or neonatal death within 1 hour or more of place for inpatient care/hospital',
        short_name: '% of households within 1 hour or more of place for inpatient care/hospital',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:04.714496Z',
        updated_at: '2023-05-24T10:16:02.973109Z',
        factor: 2,
        first_related: 645,
        second_related: 647,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 647,
        full_name: 'Percentage of households with a stillbirth or neonatal death within walking distance of place for inpatient care/hospital',
        short_name: '% of households within walking distance of place for inpatient care/hospital',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:06.360053Z',
        updated_at: '2023-05-24T10:16:11.321395Z',
        factor: 2,
        first_related: 645,
        second_related: 646,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 648,
        full_name: 'Percentage of women with a stillbirth or neonatal death who went to a health provider for ANC',
        short_name: '% of women with a stillbirth or neonatal death who went to a health provider for ANC',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:07.704158Z',
        updated_at: '2023-05-24T10:16:23.338177Z',
        factor: 2,
        first_related: 5,
        second_related: 6,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 649,
        full_name: 'Percentage of women with a stillbirth or neonatal death who had hypertension before pregnancy',
        short_name: '% of women with a stillbirth or neonatal death who had hypertension before pregnancy',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:09.024945Z',
        updated_at: '2023-05-24T10:16:35.052183Z',
        factor: 2,
        first_related: 650,
        second_related: 653,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 650,
        full_name: 'Percentage of women with a stillbirth or neonatal death who had heart disease before pregnancy',
        short_name: '% of women with a stillbirth or neonatal death who had heart disease before pregnancy',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:10.400291Z',
        updated_at: '2023-05-24T10:16:41.367244Z',
        factor: 2,
        first_related: 649,
        second_related: 653,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 651,
        full_name: 'Percentage of women with a stillbirth or neonatal death who had diabetes before pregnancy',
        short_name: '% of women with a stillbirth or neonatal death who had diabetes before pregnancy',
        desirable_slope: 'Negative',
        indicator_type: 'Impact',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:11.803997Z',
        updated_at: '2023-05-24T10:16:46.781853Z',
        factor: 2,
        first_related: 649,
        second_related: 653,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 652,
        full_name: 'Percentage of women with a stillbirth or neonatal death who had epilepsy before pregnancy',
        short_name: '% of women with a stillbirth or neonatal death who had epilepsy before pregnancy',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:13.297701Z',
        updated_at: '2023-05-24T10:16:52.934458Z',
        factor: 2,
        first_related: 649,
        second_related: 653,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 653,
        full_name: 'Percentage of women with a stillbirth or neonatal death who had complications in the last three months of pregnancy',
        short_name: '% of women with a stillbirth or neonatal death who had complications in the last three months of pregnancy',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:14.680700Z',
        updated_at: '2023-05-24T10:17:01.344307Z',
        factor: 2,
        first_related: 654,
        second_related: 651,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 654,
        full_name: 'Percentage of women with a stillbirth or neonatal death who had complications in labour and delivery',
        short_name: '% of women with a stillbirth or neonatal death who had complications in labour and delivery',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:16.377666Z',
        updated_at: '2023-05-24T10:17:11.858543Z',
        factor: 2,
        first_related: 653,
        second_related: 649,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 655,
        full_name: 'Percentage of neonatal death caused by Sepsis',
        short_name: '% of neonatal death caused by Sepsis',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:17.764712Z',
        updated_at: '2023-05-24T10:17:13.124697Z',
        factor: 2,
        first_related: 656,
        second_related: 659,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 656,
        full_name: 'Percentage of neonatal death caused by Pneumonia',
        short_name: '% of neonatal death caused by Pneumonia',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:19.118780Z',
        updated_at: '2023-05-24T10:17:14.380651Z',
        factor: 2,
        first_related: 655,
        second_related: 659,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 657,
        full_name: 'Percentage of neonatal death caused by Meningitis',
        short_name: '% of neonatal death caused by Meningitis',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:20.649277Z',
        updated_at: '2023-05-24T10:17:15.650631Z',
        factor: 2,
        first_related: 661,
        second_related: 664,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 658,
        full_name: 'Percentage of neonatal death caused by Intrapartum-related injury',
        short_name: '% of neonatal death caused by Intrapartum-related injury',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:22.007948Z',
        updated_at: '2023-05-24T10:17:17.044013Z',
        factor: 2,
        first_related: 661,
        second_related: 663,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 659,
        full_name: 'Percentage of neonatal death caused by Jaundice',
        short_name: '% of neonatal death caused by Jaundice',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:23.264815Z',
        updated_at: '2023-05-24T10:17:18.281754Z',
        factor: 2,
        first_related: 655,
        second_related: 656,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 660,
        full_name: 'Percentage of neonatal death caused by Preterm birth',
        short_name: '% of neonatal death caused by Preterm birth',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:24.638506Z',
        updated_at: '2023-05-24T10:17:20.288770Z',
        factor: 2,
        first_related: 661,
        second_related: 663,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 661,
        full_name: 'Percentage of neonatal death caused by Cognenital abnormalities',
        short_name: '% of neonatal death caused by Cognenital abnormalities',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:26.026181Z',
        updated_at: '2023-05-24T10:17:21.723375Z',
        factor: 2,
        first_related: 660,
        second_related: 663,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 662,
        full_name: 'Percentage of neonatal death caused by Diarrhoea',
        short_name: '% of neonatal death caused by Diarrhoea',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:27.313371Z',
        updated_at: '2023-05-24T10:17:22.998912Z',
        factor: 2,
        first_related: 656,
        second_related: 655,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 663,
        full_name: 'Percentage of neonatal death caused by Birth injury (Birth trauma)',
        short_name: '% of neonatal death caused by Birth injury (Birth trauma)',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:28.879455Z',
        updated_at: '2023-05-24T10:17:24.385712Z',
        factor: 2,
        first_related: 660,
        second_related: 661,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 664,
        full_name: 'Percentage of neonatal death caused by Injury Neonatal tetanus',
        short_name: '% of neonatal death caused by Injury Neonatal tetanus',
        desirable_slope: 'Negative',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: null,
        national_source: null,
        national_information: null,
        sdg_target: null,
        sdg_information: null,
        created_at: '2023-05-05T13:51:30.360519Z',
        updated_at: '2023-05-24T10:17:25.662824Z',
        factor: 2,
        first_related: 663,
        second_related: 661,
        third_related: null,
        fourth_related: null,
        datasources: [
          32,
        ],
        group: [],
      },
      {
        id: 704,
        full_name: '1st ANC Visit',
        short_name: '1st ANC Visit',
        desirable_slope: 'Positive',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: '95.00',
        national_source: 'Not applicable',
        national_information: 'Not applicable',
        sdg_target: '',
        sdg_information: 'Not applicable',
        created_at: '2023-06-21T15:01:01.204299Z',
        updated_at: '2023-07-11T14:59:38.102378Z',
        factor: 2,
        first_related: 5,
        second_related: 6,
        third_related: null,
        fourth_related: null,
        datasources: [
          25,
        ],
        group: [],
      },
      {
        id: 705,
        full_name: '4th ANC Visit',
        short_name: '4th ANC Visit',
        desirable_slope: 'Positive',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: '90.00',
        national_source: 'Not applicable',
        national_information: 'Not applicable',
        sdg_target: '',
        sdg_information: 'Not applicable',
        created_at: '2023-06-21T15:05:08.274921Z',
        updated_at: '2023-07-11T15:05:52.406381Z',
        factor: 2,
        first_related: 5,
        second_related: 6,
        third_related: null,
        fourth_related: null,
        datasources: [
          25,
        ],
        group: [],
      },
      {
        id: 706,
        full_name: 'Skilled Birth Attendance',
        short_name: 'Skilled Birth Attendance',
        desirable_slope: 'Positive',
        indicator_type: 'Outcome',
        program_area: 'RMNCH',
        national_target: '57.00',
        national_source: 'NSHDP II & NRHP 2017',
        national_information: 'Target obtained from the National Reproductive Health Policy (NRHP) 2017 to 2021',
        sdg_target: '',
        sdg_information: 'Not applicable',
        created_at: '2023-06-21T15:06:43.156729Z',
        updated_at: '2023-07-03T12:41:27.701900Z',
        factor: 2,
        first_related: 5,
        second_related: 6,
        third_related: null,
        fourth_related: null,
        datasources: [
          25,
        ],
        group: [],
      },
    ],
  },
  index: 0,
};

export default Rmnch;
